// console.log("SCRIPT_LOAD: drawercart3.js // speed improvements");

if (typeof Shopify === "undefined") {
  window.Shopify = {};
}

if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function(callback, data) {
    if (!data) {
      return jQuery.getJSON("/cart.js", function(cart, status, xhr) {
        if (typeof callback === "function") {
          callback(cart, status, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    }
    if (typeof callback === "function") {
      callback(data);
    } else if (typeof Shopify.onCartUpdate === "function") {
      Shopify.onCartUpdate(data);
    }
  };
}

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, formatString) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = formatString || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    // apply defaults
    thousands = defaultOption(thousands, ",");
    decimal   = defaultOption(decimal, ".");

    var parts = (number / 100).toFixed(defaultOption(precision, 2)).split(".");

    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );

    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents,                2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents,                0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents,                2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents,                0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class GoCart {
  constructor(options) {
    this.defaults = Object.assign({
      cartModalFail: ".js-go-cart-modal-fail",
      cartModalFailClose: ".js-go-cart-modal-fail-close",
      cartModal: ".js-go-cart-modal",
      cartModalClose: ".js-go-cart-modal-close",
      cartModalContent: ".js-go-cart-modal-content",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".js-go-cart-drawer-footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartMiniCart: ".js-go-cart-mini-cart",
      cartMiniCartContent: ".js-go-cart-mini-cart-content",
      cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
      cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
      cartTrigger: ".js-go-cart-trigger",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      removeFromCart: ".js-go-cart-remove-from-cart",
      removeFromCartNoDot: "js-go-cart-remove-from-cart",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartMode: "drawer",
      drawerDirection: "right",
      displayModal: false,
      moneyFormat: "${{amount}}",
      labelAddedToCart: "was added to your cart.",
      labelCartIsEmpty: "Your Cart is currently empty!",
      labelQuantity: "Quantity:",
      labelRemove: "Remove"
    }, options);

    // Cache DOM elements
    this.cartModalFail      = document.querySelector(this.defaults.cartModalFail);
    this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
    this.cartModal          = document.querySelector(this.defaults.cartModal);
    this.cartModalClose     = document.querySelectorAll(this.defaults.cartModalClose);
    this.cartModalContent   = document.querySelector(this.defaults.cartModalContent);
    this.cartDrawer         = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent  = document.querySelector(this.defaults.cartDrawerContent);
    this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
    this.cartDrawerFooter   = document.querySelector(this.defaults.cartDrawerFooter);
    this.cartDrawerClose    = document.querySelector(this.defaults.cartDrawerClose);
    this.cartMiniCart       = document.querySelector(this.defaults.cartMiniCart);
    this.cartMiniCartContent= document.querySelector(this.defaults.cartMiniCartContent);
    this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
    this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
    this.cartTrigger        = document.querySelectorAll(this.defaults.cartTrigger);
    this.cartOverlay        = document.querySelector(this.defaults.cartOverlay);
    this.cartCount          = document.querySelector(this.defaults.cartCount);
    this.addToCart          = document.querySelectorAll(this.defaults.addToCart);
    this.removeFromCart     = this.defaults.removeFromCart;
    this.removeFromCartNoDot= this.defaults.removeFromCartNoDot;
    this.itemQuantity       = this.defaults.itemQuantity;
    this.itemQuantityPlus   = this.defaults.itemQuantityPlus;
    this.itemQuantityMinus  = this.defaults.itemQuantityMinus;
    this.cartMode           = this.defaults.cartMode;
    this.drawerDirection    = this.defaults.drawerDirection;
    this.displayModal       = this.defaults.displayModal;
    this.moneyFormat        = this.defaults.moneyFormat;
    this.labelAddedToCart   = this.defaults.labelAddedToCart;
    this.labelCartIsEmpty   = this.defaults.labelCartIsEmpty;
    this.labelQuantity      = this.defaults.labelQuantity;
    this.labelRemove        = this.defaults.labelRemove;

    this.init();
  }

  get isDrawerMode() {
    return this.cartMode === "drawer";
  }

  init() {
    this.fetchCart();

    if (this.isDrawerMode) {
      this.setDrawerDirection();
    } else {
      document.querySelector(".go-cart-wrp").classList.add("mini-cart");
    }

    // Add to cart handler
    document.addEventListener("click", (evt) => {
      // Use .closest() to catch clicks on the spinner/text inside the button
      const addToCartBtn = evt.target.closest(this.defaults.addToCart);
      
      if (addToCartBtn) {
        evt.preventDefault(); // REQUIREMENT: Prevent redirect to /cart immediately
        
        let formEl = addToCartBtn.closest("form");
        if (!formEl) return;
        
        const formId = formEl.getAttribute("id");
        
        // SAFETY: Handle the whitespace-only inventoryNote div
        const qtyInput = document.querySelector('input[name="quantity"]');
        const inventoryNote = document.querySelector(".inventoryNote");
        
        let shouldAdd = true;
        if (qtyInput && inventoryNote) {
            const desiredQty = parseInt(qtyInput.value, 10);
            // .trim() removes the whitespace/newlines you showed
            const invText = inventoryNote.textContent.trim();
            const available = parseInt(invText, 10);

            // If there's a number and we're over it, stop the add
            if (!isNaN(available) && desiredQty > available) {
                shouldAdd = false;
            }
        }

        if (shouldAdd) {
          // Pass the button to the function to show the "adding" spinner
          this.addItemToCart(formId, addToCartBtn);
        }
      }
    }, false);

    // Cart trigger (drawer/mini)
    this.cartTrigger.forEach(btn => {
      btn.addEventListener("click", () => {
        if (this.isDrawerMode) {
          this.openCartDrawer();
        } else {
          this.openMiniCart();
        }
        this.openCartOverlay();
      });
    });

    // Overlay close
    this.cartOverlay.addEventListener("click", () => {
      this.closeCartModal();
      if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
      this.closeCartOverlay();
    });

    // Drawer close
    if (this.isDrawerMode && this.cartDrawerClose) {
      this.cartDrawerClose.addEventListener("click", () => {
        this.closeCartDrawer();
        this.closeCartOverlay();
      });
    }

    // Modal close buttons
    if (this.displayModal) {
      this.cartModalClose.forEach(el => {
        el.addEventListener("click", () => {
          this.closeCartModal();
          if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
          this.closeCartOverlay();
        });
      });
    }

    // Fail modal close
    if (this.cartModalFailClose) {
      this.cartModalFailClose.addEventListener("click", () => {
        this.closeCartModal();
        if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
        this.closeCartOverlay();
      });
    }
  }

  fetchCart(callback) {
    fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then(r => r.json())
      .then(cart => this.fetchHandler(cart, callback))
      .catch(err => { this.ajaxRequestFail(); throw err; });
  }

  addItemToCart(formId, btnElement) {
    // 1. Show the "adding" spinner immediately
    if (btnElement) btnElement.classList.add("adding");

    const form = document.querySelector(`#${formId}`);
    if (!form) {
      if (btnElement) btnElement.classList.remove("adding");
      return;
    }

    // 2. Fire the POST request immediately (removes the 2.5s delay)
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(r => r.json())
    .then((addedItem) => {
      // 3. Handle the Free Gift UI Lockout (v1 Restoration)
      if (window.jQuery) {
        jQuery.getJSON("/cart.js", (t) => {
          let hasFreeItem = t.items.some(it => 
            it.product_title !== "Free Gift w/ Purchase" && 
            it.product_title.toLowerCase().startsWith("free")
          );

          if (hasFreeItem) {
            jQuery(".FreeProductGridContainer .preview-card").each(function () {
              jQuery(this).find(".form").remove();
              jQuery(this).append(
                '<button class="btn_disable btn_full" style="margin-top: 16px;" disabled="">UNAVAILABLE - FREE PRODUCT ALREADY IN CART</button>'
              );
              jQuery(this).removeClass("open");
            });
          }
        });
      }

      // 4. Open the drawer immediately
      this.addItemToCartHandler(addedItem);
    })
    .catch(err => { 
      this.ajaxRequestFail(); 
      console.error("Cart error:", err);
    })
    .finally(() => {
      // 5. Hide the spinner as soon as the request finishes
      if (btnElement) btnElement.classList.remove("adding");
    });
  }

  removeItem(line) {
    Shopify.getCart(function() {
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(r => r.json())
      .then(() => this.fetchCart())
      .catch(err => { this.ajaxRequestFail(); throw err; });
    }.bind(this));
  }

  changeItemQuantity(line, qty, freeLinePrice) {
    Shopify.getCart(function() {
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(r => r.json())
      .then(() => this.fetchCart())
      .catch(err => { this.ajaxRequestFail(); throw err; });
    }.bind(this));
  }

   changeItemSellingPlan(line, qty, sellingPlanId) {
    Shopify.getCart(function() {
      const payload = { line: line, quantity: qty };
      if (sellingPlanId) {
        payload.selling_plan = sellingPlanId;
      } else {
        payload.selling_plan = null;
      }
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(payload)
      })
      .then(r => r.json())
      .then(() => this.fetchCart())
      .catch(err => { this.ajaxRequestFail(); throw err; });
    }.bind(this));
  }

  needsSubProductData(item) {
    if (!window.SUB_PRODUCT_DATA_ENABLED) return false;

    if (!item || !item.variant_id) return false;
    if (this._subDataUnavailable) return false;
    if (!window.SUB_PRODUCT_DATA) return !this._subDataFetchedOnce;
    if (Object.prototype.hasOwnProperty.call(window.SUB_PRODUCT_DATA, item.variant_id)) return false;
    return !this._subDataFetchedOnce;
  }

  fetchCartSubData() {
    if (this._subDataUnavailable) return Promise.resolve(window.SUB_PRODUCT_DATA || {});
    if (this._subDataFetchPromise) return this._subDataFetchPromise;
    this._subDataFetchPromise = fetch("/cart?view=cart-data", { credentials: "same-origin" })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && data.items && typeof data.items === "object") {
          window.SUB_PRODUCT_DATA = data.items;
          this._subDataUnavailable = false;
          this._subDataFetchedOnce = true;
          return window.SUB_PRODUCT_DATA;
        }
        window.SUB_PRODUCT_DATA = window.SUB_PRODUCT_DATA || {};
        this._subDataUnavailable = true;
        this._subDataFetchedOnce = true;
        return window.SUB_PRODUCT_DATA;
      })
      .catch(() => {
        window.SUB_PRODUCT_DATA = window.SUB_PRODUCT_DATA || {};
        this._subDataUnavailable = true;
        this._subDataFetchedOnce = true;
        return window.SUB_PRODUCT_DATA;
      })
      .finally(() => {
        this._subDataFetchPromise = null;
      });

    return this._subDataFetchPromise;
  }

  getSubscriptionDataForItem(item) {
    if (!window.SUB_PRODUCT_DATA) return null;
    const key = String(item.variant_id);
    let plans = window.SUB_PRODUCT_DATA[key] || window.SUB_PRODUCT_DATA[item.variant_id] || null;

    return plans;
  }

  getUniquePlans(plans) {
    const seen = new Set();
    return (plans || []).filter(plan => {
      if (!plan || !plan.name || !plan.id) return false;
      const label = String(plan.name);
      if (seen.has(label)) return false;
      seen.add(label);
      return true;
    });
  }

  /* Builds the HTML for the subscribe and save toggle and dropdown based on the item's subscription data */
  buildSubscribeAndSaveHtml(item, line) {
  if (!window.SUB_PRODUCT_DATA_ENABLED) return "";

  const subData = this.getSubscriptionDataForItem(item);
    if (!subData || !Array.isArray(subData.plans) || subData.plans.length === 0) return "";

  const inVipCollection = Array.isArray(subData.collections)
    ? subData.collections.some(handle => {
        const h = String(handle);
        return h.includes("platinum-vip-ll") || h.includes("mens-monthly-skincare-routines");
      })
    : false;
  
  const excludedProductIds = ["7302864535627"];
  const excludedDiscounts = ["NC20OFF", "NC30OFF", "NEW20", "NCFREEGIFTS"];

  // --- Check Session Storage for active discount ---
  const sessionDiscount = sessionStorage.getItem("active_discount_code");
  const hasExcludedSessionDiscount = sessionDiscount && excludedDiscounts.includes(sessionDiscount.toUpperCase());

  // Log the result for debugging
  if (hasExcludedSessionDiscount) {
    console.log(`%c GoCart: Hiding Subscribe & Save. Session discount "${sessionDiscount}" matches exclusion list.`, "color: #ff0000; font-weight: bold;");
  } else if (sessionDiscount) {
    console.log(`GoCart: Session discount "${sessionDiscount}" detected but not on exclusion list.`);
  }

  const hasBundleProperty =
    item.properties &&
    (item.properties['_rc_bundle'] || item.properties['__upsell_id']);

  const hasExcludedDiscount =
    item.line_level_discount_allocations?.some(discount =>
      excludedDiscounts.includes(discount.discount_application.title)
    );

  const shouldExclude =
    inVipCollection ||
    excludedProductIds.includes(String(item.product_id)) ||
    hasBundleProperty ||
    hasExcludedDiscount ||
    hasExcludedSessionDiscount; // Added session storage check here

  if (shouldExclude) { return ""; }

    const isSubscription = !!item.selling_plan_allocation;

    if (isSubscription){return "";} // Allow the toggle to be visible only to one-time products

    const currentPlanId = isSubscription && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : null;
    const uniquePlans = this.getUniquePlans(subData.plans);
    if (uniquePlans.length === 0) return "";

    const availablePlansStr = uniquePlans
      .map(plan => `${plan.name}|${plan.id}`)
      .join(",");
    const availablePlansAttr = availablePlansStr.replace(/"/g, "&quot;");

    const currentFrequency = isSubscription && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.name.replace("Subscription:", "").trim()
      : "";

    // Only include specific plans and sort them by frequency
    const validNames = ["Delivery every 30 days", "Delivery every 60 days", "Delivery every 90 days"];
    const dropdownOptions = uniquePlans
      .filter(plan => plan.name.includes("Subscription:"))
      .sort((a, b) => {
        const daysA = parseInt(a.name.match(/\d+/)?.[0] || 0, 10);
        const daysB = parseInt(b.name.match(/\d+/)?.[0] || 0, 10);
        return daysA - daysB;
      })
      .map(plan => {
        const selected = currentPlanId && String(plan.id) === String(currentPlanId);
        const label = plan.name.replace("Subscription: Delivery every", "").trim();
        return `<button type="button" class="drawer-subscribe-option ${selected ? "selected" : ""}" data-plan-id="${plan.id}">${label}</button>`;
      })
      .join("");

    return `
      <div class="subscribe-and-save-row" data-line="${line}">
        <div class="drawer-subscribe-and-save">
          <label class="drawer-toggle">
            <input type="checkbox" class="drawer-toggle__input"
              data-item-key="${item.key}"
              data-quantity="${item.quantity}"
              data-available-plans="${availablePlansAttr}"
              ${currentPlanId ? `data-current-selling-plan-id="${currentPlanId}"` : ""}
              ${isSubscription ? "checked" : ""}>
            <span class="drawer-slider"></span>
          </label>
          
          <div class="flex flex-column flex-align-center">
              <div class="subscribe-and-save-text sas_dcart">
            {% comment %}Subscribe and Save 20% <span class="fw_300">on your first<br> order and 10% off all recurring orders</span>{% endcomment %}
            
            Subscribe and Save 10%
            
            
          </div>
          
              ${isSubscription ? `
              <div class="drawer-subscribe-autoship mt6">
                <span class="drawer-subscribe-frequency">${currentFrequency}</span>
                <button type="button" class="drawer-subscribe-edit">Edit</button>
              </div>
            ` : ""}
          </div>
        </div>


          
        </div>
        ${isSubscription ? `
          <div class="drawer-subscribe-meta" data-item-key="${item.key}" data-quantity="${item.quantity}">
            <div class="drawer-subscribe-dropdown" hidden>
              ${dropdownOptions}
            </div>
          </div>
        ` : ""}
      </div>
    `;
  }

  bindSubscribeAndSaveHandlers() {
    const container = this.cartDrawerContent;
    if (!container) return;

    container.querySelectorAll(".drawer-subscribe-edit").forEach(btn => {
      btn.addEventListener("click", () => {
        const row = btn.closest(".subscribe-and-save-row");
        if (!row) return;
        const dropdown = row.querySelector(".drawer-subscribe-dropdown");
        if (dropdown) dropdown.hidden = !dropdown.hidden;
      });
    });

    container.querySelectorAll(".drawer-toggle__input").forEach(input => {
      input.addEventListener("change", () => {
        const row = input.closest(".subscribe-and-save-row");
        const line = row ? Number(row.getAttribute("data-line")) : null;
        const qty = Number(input.getAttribute("data-quantity")) || 1;
        const available = input.getAttribute("data-available-plans") || "";

        const sixtyDaysPlan = available.split(",")
          .find(entry => entry.includes("Delivery every 60 days") && !entry.includes("Welcome"));

        const sixtyDaysPlanId = sixtyDaysPlan ? sixtyDaysPlan.split("|")[1] : null;
        if (!sixtyDaysPlanId) return;

        if (input.checked) {
          if (sixtyDaysPlanId) this.changeItemSellingPlan(line, qty, sixtyDaysPlanId);
        } else {
          this.changeItemSellingPlan(line, qty, null);
        }
      });
    });

    container.querySelectorAll(".drawer-subscribe-option").forEach(btn => {
      btn.addEventListener("click", () => {
        const row = btn.closest(".subscribe-and-save-row");
        const line = row ? Number(row.getAttribute("data-line")) : null;
        if (!line) return;
        const planId = btn.getAttribute("data-plan-id");
        if (!planId) return;
        const toggle = row.querySelector(".drawer-toggle__input");
        const qty = toggle ? Number(toggle.getAttribute("data-quantity")) || 1 : 1;
        this.changeItemSellingPlan(line, qty, planId);
      });
    });
  }

  cartItemCount(cart) {
    document.querySelectorAll(".js-go-cart-counter")
      .forEach(el => el.innerHTML = cart.item_count);
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      if (this.isDrawerMode) this.openCartDrawer(); else this.openMiniCart();
      this.openCartOverlay();
    });
  }

  fetchAndOpenModal(item) {
    this.fetchCart(() => {
      this.renderCartModal(item);
      this.openCartModal();
      this.openCartOverlay();
    });
  }

  fetchHandler(cart, callback) {

    // --- NEW20 REMOVAL RULE ---
    const isNew20Applied = cart.items.some(item => 
      item.line_level_discount_allocations && 
      item.line_level_discount_allocations.some(a => 
        a.discount_application.title.toUpperCase().includes("NEW20")
      )
    );

    const restrictedIds = ["40077072007243", "41358312865867"];
    const kitInCart = cart.items.find(item => restrictedIds.includes(String(item.variant_id)));

    if (isNew20Applied && kitInCart) {
      // 1. OPEN DRAWER IMMEDIATELY
      // This ensures the user sees the action even while we are cleaning the cart
      this.openCartDrawer();
      this.openCartOverlay();

      // 2. REMOVE THE ITEM
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: String(kitInCart.key), quantity: 0 })
      })
      .then(r => r.json())
      .then(updatedCart => {
        // 3. RE-RENDER (Drawer is already open now)
        this.fetchHandler(updatedCart, callback);
      });
      
      return; // Stop the rest of this specific render cycle
    }
    // --- END REMOVAL RULE ---
    
    this.cartItemCount(cart);

    if (this.isDrawerMode) {
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer();
        this.cartDrawerFooter.classList.add("is-invisible");
      } else {
        this.renderDrawerCart(cart);
        this.cartDrawerFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    } else {
      if (cart.item_count === 0) {
        this.renderBlankMiniCart();
        this.cartMiniCartFooter.classList.add("is-invisible");
      } else {
        this.renderMiniCart(cart);
        this.cartMiniCartFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    }
  }

  addItemToCartHandler(item) {
    if (this.displayModal) {
      this.fetchAndOpenModal(item);
    } else {
      this.fetchAndOpenCart();
    }
  }

  ajaxRequestFail() {
    // handle AJAX failure if needed
  }

  renderCartModal(item) {
    this.clearCartModal();
    const variantText = item.variant_title ? `(${item.variant_title})` : "";
    const imgUrl = item.image || "";
    this.cartModalContent.innerHTML += `
      <div class="go-cart-modal-item">
        <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
        <div class="go-cart-item__info">
          <a href="${item.url}" class="go-cart-item__title">
            ${item.product_title} ${variantText}
          </a> ${this.labelAddedToCart}
        </div>
      </div>
    `;
  }

  renderDrawerCart(cart) {
    this.clearCartDrawer();

    // --- NEW: NC Message Logic ---
    const messageContainer = document.querySelector('.cart-drawer-message');
    if (messageContainer) {

        //Additon: Check for NEW20 specifically
        const isNew20 = cart.items.some(item => {
            return item.line_level_discount_allocations && item.line_level_discount_allocations.some(allocation => {
                return (allocation.discount_application.code || allocation.discount_application.title || "").toUpperCase().includes("NEW20");
            });
        });

        // Define your target prefixes
        const targetPrefixes = ['WELCOME-NC', 'BUNDLE-NC', 'NC'];
        // Check if any item has an allocation matching those prefixes
        const hasNCLanding = cart.items.some(item => {
            return item.line_level_discount_allocations && item.line_level_discount_allocations.some(allocation => {
                const code = (allocation.discount_application.code || allocation.discount_application.title || "").toUpperCase();
                return targetPrefixes.some(prefix => code.includes(prefix));
            });
        });

        if (isNew20) {
            // Show your NEW25/NEW20 17-Piece Kit Message
            messageContainer.innerHTML = `
                <div class="custom_gwp_message new25_bg_gradient flex flex-wrap flex-align-center justify-center">
                    <div class="cgwp-div2 flex flex-align-center justify-center width100">
                        <p class="weight500 center margin-0" style="padding-right:10px;width:60%;line-height: 1.2;font-size: 14px;">
                            Congrats! With NEW20 you earned a FREE Best Sellers Kit &amp; Hyaluronic Acid Booster &nbsp;<i class="weight350">($110 Value)</i>
                        </p>
                        <div class="flex flex-align-center justify-center" style="width:40%">
                            <img src="https://cdn.shopify.com/s/files/1/0513/2409/files/takeover-kit-gwp2.webp?v=1769110188" alt="Best Sellers Gift" title="Free Gifts w/ Purchase" width="90" height="auto" style="padding: 0;max-width: 50%;">
                            <img src="https://cdn.shopify.com/s/files/1/0513/2409/files/takeover-booster-gwp3.webp?v=1769110188" alt="Best Sellers Gift" title="Free Gifts w/ Purchase" width="90" height="auto" style="padding: 0;max-width: 50%;">
                        </div>
                    </div>
                </div>
            `;
            messageContainer.style.display = 'block';
        } else if (hasNCLanding) {
            messageContainer.innerHTML = `
                <div class="nc-discount-msg">
                    <p class="uppercase"><strong>Limited Time Gifts & Discounts Added To Cart</strong></p>
                    <p class="disclaimer">Note: Removing items from your cart will disqualify you from this offer and remove your free gifts. Checkout now to secure this limited-time deal.</p>
                </div>
            `;
            messageContainer.style.display = 'block';
        } else {
            messageContainer.innerHTML = '';
            messageContainer.style.display = 'none';
        }
    }
    // --- End NC Message Logic ---

    cart.items.forEach((item, index) => {

      let discountsHtml = '';
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
        discountsHtml = '<ul class="go-cart-item__discounts">';
        item.line_level_discount_allocations.forEach(allocation => {
          discountsHtml += `
            <li class="go-cart-item__discount-tag" style="font-size: 11px;color: #b70707;letter-spacing: 0;font-weight: 600;">
              <svg aria-hidden="true" focusable="false" viewBox="0 0 12 12" style="width:9px; fill:currentColor; margin-right:0"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h-6c-.55 0-1 .45-1 1v6l6 5 5-5-5-11zm-4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></svg>
              ${allocation.discount_application.title}
            </li>`;
        });
        discountsHtml += '</ul>';
      }

      // compute prices
      const currentLinePriceCents  = item.line_price;
      const originalLinePriceCents = item.original_price * item.quantity;
      const formattedCurrent       = Shopify.formatMoney(currentLinePriceCents,  this.moneyFormat);
      const formattedOriginal      = Shopify.formatMoney(originalLinePriceCents, this.moneyFormat);
      const showOriginal           = originalLinePriceCents > currentLinePriceCents;

      const title        = item.product_title;
      const variantTitle = item.variant_title || "";
      const imgUrlRaw    = item.image || "";
      const imgUrl       = imgUrlRaw.replace(/(\.png|\.jpe?g|\.webp)$/, `_200x320$1`);

      // free‑gift logic
      const isFree = title.toLowerCase().startsWith("free");
      const displayPriceHtml = isFree
        ? '<div class="go-cart-item__price h5 m0">FREE</div>'
        : `
          
          ${showOriginal ? `<div class="go-cart-item__price--original h6 m0"><s>${formattedOriginal}</s></div>` : ""}
          <div class="go-cart-item__price h5 m0">${formattedCurrent}</div>
          
          ${discountsHtml}

          <div class="go-cart-item__quantity">
            <span class="go-cart-item__quantity-label">${this.labelQuantity}</span>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
            <input class="go-cart-item__quantity-number js-go-cart-quantity"
                   type="number"
                   data-quantityid="${item.id}"
                   value="${item.quantity}"
                   disabled>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
          </div>
        `;

         const subscribeHtml = this.buildSubscribeAndSaveHtml(item, index + 1);

      const itemHtml = `
        <div class="go-cart-item__single" data-line="${index+1}" data-id="${item.id}" data-handle="${item.handle}">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
            <div class="go-cart-item__info">
              <div class="go-cart-item__wrp">
                ${isFree
                  ? `<span class="go-cart-item__title_free fw_600 h6 mt0 mb10">${title}</span>`
                  : `<a href="${item.url}" class="go-cart-item__title fw_600 h6 mt0 mb10">${title}</a>`
                }
                ${variantTitle ? `<div class="go-cart-item__variant fw_600 caps mt0 mb10">${variantTitle}</div>` : ""}
                <div class="remove-link fw_600 caps mt26">
                  <span class="js-go-cart-remove-from-cart">${this.labelRemove}</span>
                </div>
              </div>
              <div class="quantity-wrp mb10">
                ${displayPriceHtml}
              </div>
            </div>
          </div>
           ${subscribeHtml}
        </div>
      `;

      this.cartDrawerContent.innerHTML += itemHtml;
    });

    // update subtotal
    let freeAmount = 0;
    cart.items.forEach(item => {
      if (item.product_title.toLowerCase().startsWith("free")) {
        freeAmount += item.line_price;
      }
    });
    let subtotal = cart.total_price - freeAmount;
    this.cartDrawerSubTotal.innerHTML = Shopify.formatMoney(subtotal, this.moneyFormat);
    this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");

    // bind remove & quantity buttons
    document.querySelectorAll(this.removeFromCart).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        const qty  = Number(el.closest(".go-cart-item__single").querySelector(this.itemQuantity).value) + 1;
        this.changeItemQuantity(line, qty, 0);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach(el => {
      el.addEventListener("click", () => {
        const wrapper = el.closest(".go-cart-item__single");
        const line = wrapper.getAttribute("data-line");
        const currentQty = Number(wrapper.querySelector(this.itemQuantity).value);
        const newQty = currentQty - 1;
        if (newQty <= 0) {
          GoCart.removeItemAnimation(wrapper);
        }
        this.changeItemQuantity(line, newQty, 0);
      });
    });

    this.bindSubscribeAndSaveHandlers();

    // run any tag-based UI updates
    getTagFirstMonthFree();
  }

  renderMiniCart(cart) {
    this.clearMiniCart();
    cart.items.forEach((item, index) => {
      const formattedLine = Shopify.formatMoney(item.line_price, this.moneyFormat);
      this.cartMiniCartContent.innerHTML += `
        <div class="go-cart-item__single" data-line="${index+1}" data-id="${item.id}">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${item.image});"></div>
            <div class="go-cart-item__info">
              <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
              <div class="go-cart-item__price">${formattedLine}</div>
              <div class="go-cart-item__quantity">
                <span class="go-cart-item__quantity-label">${this.labelQuantity}</span>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                <input class="go-cart-item__quantity-number js-go-cart-quantity"
                       type="number"
                       data-quantityid="${item.id}"
                       value="${item.quantity}"
                       disabled>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
              </div>
            </div>
            <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
          </div>
        </div>
      `;
    });
    this.cartMiniCartSubTotal.innerHTML = Shopify.formatMoney(cart.total_price, this.moneyFormat);
    this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible");

    document.querySelectorAll(this.removeFromCart).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        const qty  = Number(el.closest(".go-cart-item__single").querySelector(this.itemQuantity).value) + 1;
        this.changeItemQuantity(line, qty, 0);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach(el => {
      el.addEventListener("click", () => {
        const wrapper = el.closest(".go-cart-item__single");
        const line = wrapper.getAttribute("data-line");
        const newQty = Number(wrapper.querySelector(this.itemQuantity).value) - 1;
        if (newQty <= 0) {
          GoCart.removeItemAnimation(wrapper);
        }
        this.changeItemQuantity(line, newQty, 0);
      });
    });
  }

  renderBlankCartDrawer() {
    this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
    this.clearCartDrawer();
    this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;

    // Clear the message if cart is empty
    const messageContainer = document.querySelector('.cart-drawer-message');
    if (messageContainer) {
        messageContainer.innerHTML = '';
        messageContainer.style.display = 'none';
    }
  }

  renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible");
    this.clearMiniCart();
    this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = "";
  }

  clearMiniCart() {
    this.cartMiniCartContent.innerHTML = "";
  }

  clearCartModal() {
    this.cartModalContent.innerHTML = "";
  }

  openCartDrawer() {
    this.cartDrawer.classList.add("is-open");
    document.body.classList.add("overflow-hidden");
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
  }

  openMiniCart() {
    this.cartMiniCart.classList.add("is-open");
  }

  closeMiniCart() {
    this.cartMiniCart.classList.remove("is-open");
  }

  openCartModal() {
    this.cartModal.classList.add("is-open");
  }

  closeCartModal() {
    this.cartModal.classList.remove("is-open");
  }

  openCartOverlay() {
    this.cartOverlay.classList.add("is-open");
  }

  closeCartOverlay() {
    this.cartOverlay.classList.remove("is-open");
  }

  static removeItemAnimation(el) {
    el.classList.add("is-invisible");
  }

  setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }
}

// Mini-cart close button
document.querySelector(".js-go-cart-mini-cart-close")
  .addEventListener("click", function() {
    setTimeout(() => {
      document.querySelector(".js-go-cart-mini-cart").classList.remove("is-open");
      document.querySelector(".js-go-cart-overlay").classList.remove("is-open");
    }, 100);
  });

var goCart = new GoCart({ cartMode: "drawer" });

function getTagFirstMonthFree() {
  setTimeout(() => {
    document.querySelectorAll(".go-cart-item__single").forEach(el => {
      if (first_month_free.includes(el.dataset.handle)) {
        el.querySelector(".go-cart-item__wrp").classList.add("mc-fmf");
      }
      if (limit_one.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach(q => q.classList.add("d-none"));
      }
      if (no_qty_adjust.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach(q => q.classList.add("d-none"));
      }
    });
  }, 50);
}

if (goCart.cartMode === "mini-cart") {
  document.querySelector(".js-go-cart-mini-cart").classList.remove("hidden");
}
getTagFirstMonthFree();

// console.log("first_month_free: " + first_month_free);
// console.log("limit_one: " + limit_one);
// console.log("no_qty_adjust: " + no_qty_adjust);



// --- NEW --- Removal of Takeover Kit+ Landing GWPS
// --- NEW --- Stand-Alone Restricted Product Removal (API Only + Delay)
(function() {
  const blacklistedIds = ["41501513252939", "41295600975947", "42123826692171", "42123832852555"];
  const restrictedNCVariants = ["42142473060427", "42142473125963", "42142473093195", "42142473027659"];
  const newcustomerDiscounts = [
    'BUNDLE-NC-67OFF', 'BUNDLE-NC-57OFF', 'BUNDLE-NC-51OFF', 'BUNDLE-NC-43OFF',
    'WELCOME-NC-15OFF', 'WELCOME-NC-40OFF', 'WELCOME-NC-53OFF', 'WELCOME-NC-62OFF',
    'NC20OFF', 'NC30OFF'
  ];

  let isRemoving = false;

  const handleCartLogic = async (cart) => {
    if (isRemoving || !cart || !cart.items) return;

    // 1. DELAY THE CHECK
    // This prevents "false deletions" while Shopify is still applying the code
    setTimeout(async () => {
      
      // 2. GATHER CODES
      // Codes on total cart
      const appliedCodes = [];
      if (cart.discount_applications) {
        cart.discount_applications.forEach(d => appliedCodes.push((d.code || "").toUpperCase()));
      }
      
      // Look for codes attached to specific items
      const codesOnItems = [];
      cart.items.forEach(item => {
        if (item.line_level_discount_allocations) {
          item.line_level_discount_allocations.forEach(a => {
            if (a.discount_application && (a.discount_application.code || a.discount_application.title)) {
              const code = (a.discount_application.code || a.discount_application.title).toUpperCase();
              codesOnItems.push(code);
            }
          });
        }
      });

      const allActiveCodes = [...new Set([...appliedCodes, ...codesOnItems])].filter(Boolean);
      
      // LOGS FOR VERIFICATION
      // console.log("🏷️ API CHECK - Codes on Items:", codesOnItems);

      // 3. MATCHING & SURGICAL NC REMOVAL (Using verified Codes on Items)
      const stickyCodes = ['NC20OFF', 'NC30OFF'];
      const giftsInCart = cart.items.filter(i => restrictedNCVariants.includes(String(i.variant_id)));
      
      // Identify if any of our target codes are present in the 'codesOnItems' array
      const activeNC = stickyCodes.find(code => codesOnItems.includes(code));

      if (activeNC && giftsInCart.length > 0) {
          // Count the TOTAL quantity of items currently carrying that specific code
          const currentNCQuantity = cart.items.reduce((acc, item) => {
              const vId = String(item.variant_id);
              const isGift = restrictedNCVariants.includes(vId) || blacklistedIds.includes(vId);
              
              // This is the exact check that generates your "Codes on Items" log
              const hasCode = item.line_level_discount_allocations && 
                              item.line_level_discount_allocations.some(a => {
                                  const name = (a.discount_application.code || a.discount_application.title || "").toUpperCase();
                                  return name === activeNC;
                              });

              return !isGift && hasCode ? acc + item.quantity : acc;
          }, 0);

          // console.log("📊 NC Qty Check -> Code:", activeNC, "| Total Qty:", currentNCQuantity);

          // If quantity drops, kill the whole promotion
          if (window.lastNCQty !== undefined && currentNCQuantity < window.lastNCQty) {
              // console.log("🚨 DROP DETECTED! Nuking " + activeNC);
              window.lastNCQty = currentNCQuantity;
              return executeCleanup(cart, true); 
          }
          
          window.lastNCQty = currentNCQuantity;
      }

      // --- REMAINDER OF ORIGINAL LOGIC (For BUNDLE/WELCOME) ---
      const activeNCCode = newcustomerDiscounts.find(nc => 
        allActiveCodes.some(active => active.includes(nc.toUpperCase()))
      );

      const ncCodeIsAssigned = newcustomerDiscounts.some(nc => 
        codesOnItems.includes(nc.toUpperCase())
      );

      // Logic A: Standard removal if code is gone from session
      if (giftsInCart.length > 0 && !activeNCCode) {
        return executeCleanup(cart, false);
      }

      // Logic B: Original fallback for auto-removing codes
      if (activeNCCode && !ncCodeIsAssigned && giftsInCart.length > 0) {
        return executeCleanup(cart, true);
      }

    }, 1500); // Increased delay for stability
  };

  async function executeCleanup(cart, clearAll) {
    if (isRemoving) return;
    isRemoving = true;

    try {
      if (clearAll) {
        // Use standard Shopify clear URL to ensure sticky sessions die
        await fetch("/discount/CLEAR");
      }

      const updates = {};
      cart.items.forEach(item => {
        const vId = String(item.variant_id);
        if (restrictedNCVariants.includes(vId) || blacklistedIds.includes(vId)) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length > 0) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        });
      }

      if (window.goCart) window.goCart.fetchCart();
      else window.location.reload();
    } catch (e) {
      console.error("Cleanup error:", e);
    } finally {
      setTimeout(() => { isRemoving = false; }, 1500);
    }
  }

  // Interceptors
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = arguments[0];
      if (typeof url === 'string' && (url.includes('/cart'))) {
        if (!url.includes('CLEAR') && !isRemoving) {
            const clone = response.clone();
            clone.json().then(handleCartLogic).catch(() => {});
        }
      }
      return response;
    });
  };

  if (window.jQuery) {
    jQuery(document).ajaxComplete(function(event, xhr, settings) {
      if (isRemoving || (settings.url && settings.url.includes('CLEAR'))) return;
      if (settings.url && settings.url.includes('/cart')) {
        try {
          const cart = JSON.parse(xhr.responseText);
          handleCartLogic(cart);
        } catch (e) {}
      }
    });
  }
})();